export const APP_ROOT_ID = "root";
export const MODAL_ROOT_ID = "modal-root";
export const CURSOR_ROOT_ID = "cursor-root";

export const rootEl = document.getElementById(APP_ROOT_ID);
export const modalRootEl = document.getElementById(MODAL_ROOT_ID);
export const cursorRootEl = document.getElementById(CURSOR_ROOT_ID);

export const articlePrefix = "rashifrovka_";
export const openedArticlePrefix = "statya_";
export const podcastsPrefix = "Slushat_";
